export default "__VITE_ASSET__Do0dFuq3__"